export default __webpack_public_path__ + "5a084181a114df488d03fd406be21ddc.svg";